import { replaceAccents } from '@/utils/string';

const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

export function hashAnchorKey(anchorKey: string): string {
	const normalizedAnchorKey = anchorKey.trim();

	let hash = FNV_OFFSET_BASIS;

	for (let index = 0; index < normalizedAnchorKey.length; index += 1) {
		hash ^= normalizedAnchorKey.charCodeAt(index);
		hash = Math.imul(hash, FNV_PRIME);
	}

	return (hash >>> 0).toString(36);
}

export function getAnchorId(anchorKey: string): string {
	const normalizedAnchorKey = anchorKey.trim();

	if (!normalizedAnchorKey) {
		throw new Error('Anchor key cannot be empty.');
	}

	return `anchor-${hashAnchorKey(normalizedAnchorKey)}`;
}

export function getSectionAnchorId(anchorKey: string): string {
	const normalizedAnchorKey = anchorKey.trim();

	if (!normalizedAnchorKey) {
		throw new Error('Anchor key cannot be empty.');
	}

	return replaceAccents(normalizedAnchorKey)
		.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/-title(?=-\d+$|$)/, '')
		.replace(/^-+|-+$/g, '');
}

export function resolveAnchorId(anchorKey?: string, id?: string): string | undefined {
	if (id) {
		return id;
	}

	if (!anchorKey) {
		return undefined;
	}

	return getAnchorId(anchorKey);
}
